import {tns} from 'tiny-slider/src/tiny-slider';

function slider() {
  const heroSliders = document.querySelectorAll('.image-slider');

  if (heroSliders) {
    heroSliders.forEach(heroSlider => {
      const slider = tns({
        container: heroSlider,
        items: 1,
        nav: false,
        mouseDrag: false,
        autoplay: true,
        autoplayTimeout: 5000,
        speed: 1000,
        mode: "gallery",
        animateIn: 'animate-in',
        animateOut: 'animate-out'
      });
    });
  }

  const imageGridButtons = document.querySelectorAll('.image-grid-modal-close');
  const imageGridTriggers = document.querySelectorAll('.image-grid-cell > img');
  const imageGridTriggersAlt = document.querySelectorAll('.image-grid-cell > figure');
  const heroImageGridTriggers = document.querySelectorAll('.trigger-image-grid-modal');

  if(imageGridButtons.length) {
    imageGridButtons.forEach(imageGridButton => {
      imageGridButton.addEventListener('click', function() {
        imageGridButton.parentElement.classList.remove('visible');
      });
    });
  }
  if(imageGridTriggersAlt.length) {
    imageGridTriggersAlt.forEach(imageGridTrigger => {
      imageGridTrigger.addEventListener('click', function() {
        imageGridTrigger.parentElement.parentElement.parentElement.nextElementSibling.classList.add('visible');
      });
    });
  }

  const imageGridModals = document.querySelectorAll('.image-grid-modal');

  if(heroImageGridTriggers.length && imageGridModals.length) {
    heroImageGridTriggers.forEach(imageGridTrigger => {
      imageGridTrigger.addEventListener('click', function() {
        imageGridModals[0].classList.add('visible');
      });
    });
  } else {
    heroImageGridTriggers.forEach(imageGridTrigger => {
      imageGridTrigger.remove();
    });
  }

  const imageGridSliders = document.querySelectorAll('.image-grid-slider');

  function findCenterSlide() {
    const slides = document.querySelectorAll('.image-grid-slide');

    if (slides) {
      slides.forEach(slide => {
        const prevSlide = slide.previousElementSibling;
        const nextSlide = slide.nextElementSibling;

        slide.classList.remove('center-slide');

        if (prevSlide && nextSlide && prevSlide.classList.contains('tns-slide-active') && nextSlide.classList.contains('tns-slide-active')) {
          slide.classList.add('center-slide');
        }
      });
    }
  }

  if(imageGridSliders) {
    const igSlides = document.querySelectorAll('.image-grid-cell > img, .image-grid-cell > figure');

    imageGridSliders.forEach(imageGridSlider => {
      const slider = tns({
        container: imageGridSlider,
        nav: false,
        mouseDrag: false,
        center: true,
        gutter: 10,
        items: 1,
        responsive: {
          "631": {
            items: 3
          }
        }
      });

      if (igSlides) {
        igSlides.forEach(igSlide => {
          let imageID;
          imageID = igSlide.classList[0];
          imageID = imageID.replace('img-slide-', '');
          imageID = parseInt(imageID);

          igSlide.addEventListener('click', function() {
            slider.goTo(imageID);
          });
        });
      }

      slider.events.on('indexChanged', findCenterSlide);
    });

    findCenterSlide();
  }
}

export default slider;